import formatNumberWithCommas from "../format/formatNumberWithCommas";
import "./ViewBillDetail.scss";
const ViewBillDetails = ({ billItem }) => {
  return (
    <div className="frame-layout-bill">
      <h1>{billItem.Brand}</h1>
      <h4>{billItem.Address}</h4>
      <h4>{billItem.Phone}</h4>
      <h4>{billItem.Line}*********************</h4>
      <h3>{billItem.Bill}</h3>
      <table>
        <thead>
          <tr>
            <th>Tên</th>
            <th className="center-tag">Giá</th>
            <th className="center-tag">Số Lượng</th>
            <th className="center-tag">Tổng</th>
          </tr>
        </thead>
        <tbody>
          {billItem.OrderList.map((item, index) => (
            <tr key={index}>
              <td>{item.name}</td>
              <td className="center-tag">
                {formatNumberWithCommas(item.price)}
              </td>
              <td className="center-tag">{item.totalItem}</td>
              <td className="center-tag">
                {formatNumberWithCommas(item.totalPrice)}
              </td>
            </tr>
          ))}
        </tbody>
        <tbody>
          <tr>
            <td>Thời Gian</td>
            <td className="center-tag">
              {formatNumberWithCommas(billItem.PriceOfTime)}
            </td>
            <td className="center-tag">{billItem.TotalTime}</td>
            <td className="center-tag">
              {formatNumberWithCommas(billItem.PriceOfTotalTime)}
            </td>
          </tr>
        </tbody>
      </table>
      <div className="frame-square-total-payment-billDetails">
        <h4 className="front-total-price-billDetails">
          Tổng Tiền: {formatNumberWithCommas(billItem.TotalPayment)} vnđ
        </h4>
        <h6>{billItem.Date}</h6>
        <h6>{billItem.Debt}</h6>
      </div>
      <h4>{billItem.Line}*********************</h4>
      <h5>{billItem.Goodbye}</h5>
      <h5>{billItem.SubGoodbye}</h5>
    </div>
  );
};

export default ViewBillDetails;
